/* istanbul ignore file */
/**
 * Created by rathompson on 12/17/21
 * File: AppReducer.actions.js
 * Project: MSP ©Palo Alto Networks
 * © Palo Alto Networks
 */

// Action Types
export const LOAD_APPS = 'LOAD_APPS'

export const loadApps = (apps) => ({
  type: LOAD_APPS,
  apps
})

